import { useCallback, useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { Routes } from '@/routes';
import { useHelpdesk } from '@/hooks/app';
import { formatDate } from '@/utils/func';
import { ConfigurableMode } from './ConfigurableMode';
import { HelpdeskStatus } from '@/components/helpdesk/helpdeskUtils';
import { SwiperItemAttrs } from '@/components/SwiperConfigable';
import { useTranslation } from 'react-i18next';

export default function HelpdeskMode() {

  const { fetchIssues, issues, issuesLoading, issuesError } = useHelpdesk();
  const navigate = useNavigate();
  const [t] = useTranslation(['common']);

  const items = useMemo(() => {
    return issues
      .filter(iss => iss.status.id === HelpdeskStatus.WaitQueue)
      .map(iss => {
        const item: SwiperItemAttrs = {
          id: iss.id,
          title: iss.subject,
          subTitle: String(iss.id),
          titleClassname: '',
          description: iss?.category?.name,
          secondaryDescription: formatDate(iss.created_on, 'jYYYY/jMM/jDD'),
          actionButtonContent: t('common:labels.view')
        };
        return item;
      });
  }, [issues]);

  useEffect(() => {
    fetchIssues();
  }, []);

  const onItemClick = useCallback((item: SwiperItemAttrs) => {
    navigate(Routes.HelpdeskViewIssue.replace(':issueId', String(item.id)));
  }, []);

  return (
    <ConfigurableMode
      items={items}
      variant="helpdesk"
      error={issuesError}
      loading={issuesLoading}
      onActionClick={onItemClick}
    />
  );
}
